import InfoTilesType from '~/components/@types/infoTiles';
import WeddingPlanningBook from '@zola/zola-ui/src/assets/images/icons/wedding_planning_book.svg';
import AdvisorV2 from '@zola/zola-ui/src/assets/images/icons/advisor-v2.svg';
import RegistryChecklist from '@zola/zola-ui/src/assets/images/icons/registry_checklist.svg';

const tileContent: InfoTilesType[] = [
  {
    className: 'registry-checklist',
    imgSrc: RegistryChecklist,
    imgAlt: 'wedding planning book icon',
    heading: 'Check Out Our Registry Checklist',
    href: '/registry/checklist',
  },
  {
    className: 'registry-advisor',
    imgSrc: AdvisorV2,
    imgAlt: 'registry advisor icon',
    heading: 'Contact A Registry Advisor',
    href: 'mailto:support@zola.com',
  },
  {
    className: 'wedding-planning-book',
    imgSrc: WeddingPlanningBook,
    imgAlt: 'registry checklist icon',
    heading: 'Get Expert Registry Advice',
    href: '/expert-advice/registry',
  },
];

export default tileContent;
